const UID_LINE = /^([A-Za-z][A-Za-z0-9_]{1,31})=([0-9A-Fa-f]{8,20})$/;

export function createLineBuffer() {
  let pending = "";
  return function push(chunk) {
    pending += String(chunk == null ? "" : chunk).replace(/\r/g, "");
    const parts = pending.split("\n");
    pending = parts.pop() || "";
    if (pending.length > 512) {
      pending = "";
    }
    return parts.map((line) => line.trim()).filter(Boolean);
  };
}

export function parseUidLine(line) {
  const matched = String(line || "").trim().match(UID_LINE);
  if (!matched || matched[2].length % 2 !== 0) {
    return null;
  }
  return {
    model: matched[1],
    uid: matched[2].toUpperCase(),
  };
}

export function parseInfoLine(line) {
  const text = String(line || "").trim();
  if (text.indexOf("DvicesModel=") < 0 || text.indexOf(";") < 0) {
    return null;
  }
  const info = {};
  text.split(";").forEach((pair) => {
    const index = pair.indexOf("=");
    if (index > 0) {
      info[pair.slice(0, index).trim()] = pair.slice(index + 1).trim();
    }
  });
  return info.DvicesModel ? info : null;
}

export function parseReadSecLine(line) {
  const matched = String(line || "").trim().match(/^READSEC\s+(\d+)\s+(\d+)\s+HEX=([0-9A-Fa-f]+)$/i);
  if (!matched) {
    return null;
  }
  return {
    sector: Number(matched[1]),
    block: Number(matched[2]),
    hex: matched[3].toUpperCase(),
  };
}
